import http from '../utils/http'
import { CONFIRM_SWAP_URL } from './urls'

export const confirmSwap = () => {
  return http.request("POST", CONFIRM_SWAP_URL)
}